"use client";

import { useTranslations } from "next-intl";
import NavigationLink from "@/common/navigation-link.common";
import { ForgotPasswordContext } from "@/context";
import ArrowBackwardRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import PersonOutlineRoundedIcon from "@mui/icons-material/PersonOutlineRounded";
import SendRoundedIcon from "@mui/icons-material/SendRounded";
import {
  Button,
  Card,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import ReCAPTCHA from "react-google-recaptcha";
import { useContext, useState } from "react";

export const ResetPassword = ({ mobile, setMobile }) => {
  const t = useTranslations();
  const { step, setStep } = useContext(ForgotPasswordContext);
  const [captchaToken, setCaptchaToken] = useState(null);

  const onClickSend = () => {
    if (!captchaToken) {
      alert("Please complete the reCAPTCHA.");
      return;
    }
    setStep(step + 1);
  };

  const handleCaptchaChange = (token) => {
    setCaptchaToken(token);
  };

  return (
    <Card
      sx={{
        gap: "1.5rem",
        maxWidth: "25rem",
        margin: "auto",
        padding: "2rem",
      }}
      elevation={1}
    >
      <Typography variant="h4">{t("Reset Your Password")}</Typography>
      <Typography color="light-grey" variant="body1">
        {t(
          "Please enter your registered mobile number to receive a password reset         code",
        )}
      </Typography>

      <div className="w-full flex flex-col gap-6">
        <div className="w-full flex flex-col gap-1">
          <Typography variant="body1">{t("Mobile Number")}</Typography>
          <TextField
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
            slotProps={{
              input: {
                endAdornment: (
                  <InputAdornment position="end">
                    <PersonOutlineRoundedIcon />
                  </InputAdornment>
                ),
              },
              htmlInput: {
                maxLength: 10,
                max: 10,
              },
            }}
            placeholder={t("Enter your registered mobile number")}
            variant="outlined"
            fullWidth
          />
          <Typography color="light-grey" variant="body1">
            {t("An OTP will be sent to this number for verification")}
          </Typography>
        </div>

        <div className="w-100%">
  <ReCAPTCHA
    sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
    onChange={handleCaptchaChange}
  />
</div>
        
        <Button
          onClick={onClickSend}
          variant="contained"
          fullWidth
          endIcon={<SendRoundedIcon />}
          disabled={!captchaToken}
          sx={{
            "&.Mui-disabled": {
              cursor: "not-allowed",
              pointerEvents: "auto",
            },
          }}
        >
          {t("Send Reset Code")}
        </Button>

        <NavigationLink href="/login">
          <Button
            variant="text"
            fullWidth
            startIcon={<ArrowBackwardRoundedIcon />}
          >
            {t("Back to Login")}
          </Button>
        </NavigationLink>
      </div>
    </Card>
  );
};

export default ResetPassword;
